"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_mail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b8b33788-8a07-4dca-b5d9-bd530581c7b8",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 160 112"
  }, props), /*#__PURE__*/React.createElement("title", null, "mail-new"), /*#__PURE__*/React.createElement("g", {
    id: "709e64ee-d4db-45e0-9cd1-e2f233d5abd1",
    "data-name": "Mail_new_ic"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 152,
    height: 104,
    rx: 12,
    ry: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "0597dd87-ec9b-476c-bc62-31579404d434",
    "data-name": "Cloud_download"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.73,47.77l-61.52,63.11a16.7,16.7,0,0,1-24.07,0L23.29,47.75",
    transform: "translate(-16 -40)",
    strokeLinejoin: "round"
  }))));
}

var _default = ic_mail;
exports.default = _default;